import { render, staticRenderFns } from "./authorizationSwitch.vue?vue&type=template&id=29619afc&scoped=true&"
import script from "./authorizationSwitch.vue?vue&type=script&lang=js&"
export * from "./authorizationSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29619afc",
  null
  
)

export default component.exports